import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/business-associates/$baId')({
  beforeLoad: () => {
    requirePermission('ba:read');
  },
  component: BusinessAssociateLayout,
  staticData: { crumb: 'Detail' },
});

function BusinessAssociateLayout() {
  return <Outlet />;
}
